/* eslint-disable max-lines */
/* eslint-disable max-depth */
/* eslint-disable no-case-declarations */
/* eslint-disable max-len */
/* eslint-disable complexity */
/* eslint-disable max-statements */

import FlyingOperations from '@/views/operation-details/operations-add/operation-add-execute-operation/flying-operations';
import PeriodicOperations from '@/views/operation-details/operations-add/operation-add-execute-operation/periodic-operations';
import RedemptionOperation from '@/views/operation-details/operations-add/operation-add-execute-operation/redemption-operation';
import RefundOperation from '@/views/operation-details/operations-add/operation-add-execute-operation/refund-operation';
import SubscriptionOperation from '@/views/operation-details/operations-add/operation-add-execute-operation/subscription-operation';
import TransferOperation from '@/views/operation-details/operations-add/operation-add-execute-operation/transfer-operation';
import WarningOperation from '@/views/operation-details/operations-add/operation-add-execute-operation/warning-operation';
import { generateFilAlert, generateFilNavDate } from "./notice-period-helpers";

const AUTO_CLASS_ENTRY_OPERATIONS = [
    'SUSCRIPCION',
    'SOLICITUD_SUSCRIPCION_PERIODICA',
    'SOLICITUD_TRASPASO_EXTERNO_ENTRADA',
    'SOLICITUD_TRASPASO_INTERNO'
];

export default {
    name: 'OperationAddExecuteOperation',
    props: ['newOperationState', 'productMinimums'],
    components: {
        FlyingOperations,
        RefundOperation,
        RedemptionOperation,
        SubscriptionOperation,
        PeriodicOperations,
        TransferOperation,
        WarningOperation
    },
    /**
     * @override
     */
    data() {
        return {
            operationPostBody: null,
            allowSubmit: true,
            modalConcentradosShown: false,
            limitDate: new Date(),
            relatedOperations: [],
            internalMinTarget: {},
            autoClassWarning: null,
            autoClassWarningAccepted: false,
            pendingAutoClassSubmitIsNew: null,
            upperClassWarning: null,
            upperClassWarningAccepted: false,
            pendingUpperClassSubmitIsNew: null
        };
    },

    watch: {
        // Cuando cambie el fondo destino en una operación interna, recargamos sus mínimos:
        'newOperationState.operationObj.product_target'(pt) {
          if (
            this.newOperationState.operationTypeSelected.key_name ===
              'SOLICITUD_TRASPASO_INTERNO' &&
            pt &&
            pt.key_name
          ) {
            this.loadInternalMinTarget(pt.key_name);
          }
        }
    },

    async created() {
        try {
            const configResponse = await this.$usersService.getConfigVarByKey('REFUND_LIMIT_DATE', {});
            const dateObject = JSON.parse(configResponse.data.configuration.value);

            this.limitDate = new Date(dateObject.year, dateObject.month, dateObject.day);
        } catch (err) {
            console.error(err);
        }
        this.fetchDataOperations();
    },

    /**
     * @override
     */
    computed: {
        productMinimumsForTransfer() {
            if ( this.newOperationState.operationTypeSelected.key_name === 'SOLICITUD_TRASPASO_INTERNO' ) {
                return {
                    source: this.productMinimums,
                    target: this.internalMinTarget
                }
            }
        },
        /**
         * Devuelve las operaciones en vuelo (pendientes), ya sea por reembolso o traspaso interno y que afecten al fondo actualmente seleccionado.
         * El fondo afectado se compara con `key_product`, que en ambos tipos indica el fondo de salida.
         */
        operationsInFlying() {
            return (this.relatedOperations || []).filter(op =>
              !['FINALIZED','CANCELLED'].includes(op.operation_status) &&
              ['REEMBOLSO','SOLICITUD_TRASPASO_INTERNO'].includes(op.key_operation_type) &&
              op.key_product === this.newOperationState.productSelected.key_name
            );
        },
        hasOperationsInFlight() {
            const flights = this.operationsInFlying;
            return flights.length > 0
        },          
        /**
         * Calcula las participaciones disponibles para operar en el producto seleccionado,
         * restando del saldo actual y las participaciones en vuelo.
         *
         * Si la operación pendiente está expresada en participaciones (indicator === 'P'), se usa directamente el campo `shares`.
         * Si la operación está expresada en importe (indicators 'B' o 'I'), se convierte el importe a participaciones usando el último valor liquidativo.
         */
        availableShares() {
            const balanceShares = +this.newOperationState.maxSharesToRefund || 0
            const nav = +this.newOperationState.productSelected.net_asset_value || 1

            const sharesInFlying = this.operationsInFlying && this.operationsInFlying.reduce((total, op) => {
                if (op.amount_shares_indicator === 'P') return total + Number(op.shares || 0);
                else if (['B', 'I'].includes(op.amount_shares_indicator)) {
                    const amount = Number(op.gross_amount || op.net_amount || 0);
                    return total + (amount / nav);
                }
            }, 0) || 0;

            const availables = balanceShares - sharesInFlying;
            return  availables >= 0 ? availables : 0;
        },
        /**
        * If operation type are aportation, controll if the limit of aportation are exceeded
        * @return {Boolean} limit of aportation exceeded or not
        */
        limitExceeded() {
            const { operationTypeSelected, amountSharesIndicator, operationObj, productSelected } = this.newOperationState;
            const nav = +productSelected.net_asset_value || 1;
            const indicatorKey = amountSharesIndicator ? amountSharesIndicator.key : 'B';
            const isShares = indicatorKey === 'P';
            const isImport = indicatorKey === 'B' || indicatorKey === 'I';
        
            if (!indicatorKey || !operationObj || !productSelected) return false;
        
            const amount = isImport ? +operationObj.grossAmount : +operationObj.netAmount;
            const localShares = operationObj.shares ? +operationObj.shares : amount / nav;
        
            // --- REEMBOLSO ---
            if (operationTypeSelected.key_name.includes('REEMBOLSO')) {
                const minToMaintain = +this.minToMantain;
                const maxValueGross = (this.availableShares * nav) - minToMaintain;
        
                let maxToRefund;

                if (indicatorKey === 'T') return false; // Reembolso total, sin límite
        
                if (isShares) {
                    maxToRefund = Math.max(0, this.availableShares - minToMaintain / nav);
                } else {
                    maxToRefund = Math.max(0, maxValueGross);
                }
                return localShares > maxToRefund;
            }
        
            // --- TRASPASO INTERNO ---
            if (operationTypeSelected.key_name === 'SOLICITUD_TRASPASO_INTERNO') {
                
                const nav  = +productSelected.net_asset_value || 1;
                const minMaintain = +this.minToMantain;
                const maxOriginAmt = this.availableShares * nav - minMaintain;
                const shares= +operationObj.shares || 0;

                // 1) ORIGEN: importe en € siempre
                let amtOrigin;

                if ( isShares) amtOrigin = shares * nav;
                else if ( isImport ) amtOrigin = +operationObj.grossAmount || operationObj.netAmount;

                // Dejar mín. a mantener
                if (!operationObj.is_total_transfer && amtOrigin < minMaintain) return true;
                // No exceder saldo disponible
                if (!operationObj.is_total_transfer && amtOrigin > maxOriginAmt) return true;

                // 2) DESTINO (si no es total transfer)
                // Solo verificar el mínimo, no el máximo (en traspasos internos no aplica límite máximo)
                if (!operationObj.is_total_transfer) {
                    const minT = +this.productMinimumsForTransfer.target.minimum_investment || 0;
                    // const maxT = this.productMinimumsForTransfer.target.maximum_investment;

                    if ( isShares ) {
                        const minShares = minT / nav;
                        // const maxShares = maxT != null ? maxT / nav : Infinity;

                        if (shares < minShares) return true;
                        // Comentado: En traspasos internos no aplica límite máximo
                        // if (shares > maxShares) return true;

                    } else {
                        if (amtOrigin < minT) return true;
                        // Comentado: En traspasos internos no aplica límite máximo
                        // if (maxT != null && amtOrigin > maxT) return true;
                    }
                }
                return false;
            }
            if (this.newOperationState.operationTypeSelected.key_name !== 'APORTACION') {
                return false;
            }
        
            return false;
        },

        nrbeRequired() {
            return this.$store.getters['configVarsStore/getNrbeRequired'];
        },
        allowAutoClassSelection() {
            return this.$store.getters['configVarsStore/getAllowAutoClassSelection'];
        },
        autoClassSelectionWarning() {
            if (!this.allowAutoClassSelection) return null;

            const operationType = this.newOperationState.operationTypeSelected &&
                this.newOperationState.operationTypeSelected.key_name;

            if (!AUTO_CLASS_ENTRY_OPERATIONS.includes(operationType)) return null;

            const product = this.getAutoClassBaseProduct();
            
            if (!product) return null;

            return this.getAutoClassSelectionWarning(product);
        },
        /**
         * Computed property to control if can submit operations (if all fields required are filled)
         * @return {Boolean} can submit or not
         */
        canSubmitOperation() {
            let canSubmit = false;
            let lessSharesThanMaximum;
            const isPayMethodCheck = this.newOperationState.operationObj.pay_method &&
                this.newOperationState.operationObj.pay_method.name === 'CHEQUE';
            const shares = this.newOperationState.operationObj.shares;
            const netAmount = this.newOperationState.operationObj.netAmount;
            let grossAmount = this.newOperationState.operationObj.grossAmount;
            switch (this.newOperationState.operationTypeSelected.key_name) {
                case 'REEMBOLSO':
                    lessSharesThanMaximum = shares ? shares <= this.newOperationState.maxSharesToRefund : false;
                    if (
                        this.newOperationState.amountSharesIndicator &&
                        this.newOperationState.source &&
                        this.newOperationState.bankAccount &&
                        (netAmount || grossAmount || (shares && lessSharesThanMaximum))
                    ) {
                        canSubmit = true;
                    } else if (this.newOperationState.amountSharesIndicator) {
                        canSubmit = canSubmit || this.newOperationState.amountSharesIndicator.key === 'T';
                    }

                    break;
                case 'SOLICITUD_REEMBOLSO_PERIODICO':
                    lessSharesThanMaximum = shares ? shares <= this.newOperationState.maxSharesToRefund : false;
                    if (
                        this.newOperationState.amountSharesIndicator &&
                        this.newOperationState.source &&
                        this.newOperationState.bankAccount &&
                        (netAmount || grossAmount || (shares && lessSharesThanMaximum)) &&
                        this.newOperationState.operationObj.per_period &&
                        this.newOperationState.operationObj.per_start_date &&
                        (this.newOperationState.operationObj.is_per_end_date_undefined === true || this.newOperationState.operationObj.per_end_date) &&
                        (this.newOperationState.operationObj.per_increase_type.key === 'no-increase' ||
                            (this.newOperationState.operationObj.per_increase &&
                                this.newOperationState.operationObj.per_increase_period))
                    ) {
                        canSubmit = true;
                    }
                    break;
                case 'SUSCRIPCION':
                    grossAmount = Number(netAmount);

                    if (
                        this.newOperationState.source &&
                        this.newOperationState.operationObj.pay_method &&
                        netAmount &&
                        (grossAmount ||
                            this.newOperationState.operationObj.shares) &&
                        (Number(this.minSuscription) <= Number(grossAmount) &&
                        Number(grossAmount) <= Number(this.maxSuscription))
                    ) {
                        canSubmit = true;
                    }
                    if (!isPayMethodCheck && !this.newOperationState.bankAccount) {
                        canSubmit = false;
                    }
                    break;
                case 'SOLICITUD_SUSCRIPCION_PERIODICA':
                    if (
                        this.newOperationState.source &&
                        netAmount &&
                        this.newOperationState.operationObj.pay_method &&
                        (grossAmount || shares) &&
                        this.newOperationState.operationObj.per_period &&
                        this.newOperationState.operationObj.per_start_date &&
                        (this.newOperationState.operationObj.is_per_end_date_undefined === true || this.newOperationState.operationObj.per_end_date) &&
                        this.newOperationState.bankAccount &&
                        (this.newOperationState.operationObj.per_increase_type.key === 'no-increase' ||
                            (this.newOperationState.operationObj.per_increase &&
                                this.newOperationState.operationObj.per_increase_period)) &&
                        Number(this.minSuscription) <= Number(grossAmount)
                    ) {
                        canSubmit = true;
                    }
                    break;
                case 'SOLICITUD_TRASPASO_INTERNO':
                    if (
                        this.newOperationState.source &&
                        this.newOperationState.amountSharesIndicator &&
                        this.newOperationState.operationObj.product_target
                    ) {
                        const newOperationState = this.newOperationState;
                        let isOverLimitMinimal = true;
                        if (this.newOperationState.amountSharesIndicator.key === 'P') {
                            isOverLimitMinimal =
                                Number(
                                    this.minToMantain /
                                        newOperationState.operationObj.product_target.net_asset_value
                                ) <= Number(shares);
                            canSubmit =
                                isOverLimitMinimal &&
                                newOperationState.operationObj.shares <= newOperationState.maxSharesToRefund;
                        }
                        if (this.newOperationState.amountSharesIndicator.key === 'B') {
                            isOverLimitMinimal =
                                Number(this.minToMantain) <=
                                Number(grossAmount);
                            canSubmit =
                                isOverLimitMinimal &&
                                newOperationState.operationObj.grossAmount <=
                                    Number(
                                        newOperationState.maxSharesToRefund *
                                            newOperationState.productSelected.net_asset_value
                                    );
                        }

                        canSubmit = canSubmit || this.newOperationState.amountSharesIndicator.key === 'T';
                    }
                    break;
                case 'SOLICITUD_TRASPASO_EXTERNO_ENTRADA':
                    // De fondo de inversión
                    if (this.newOperationState.operationTypeSelected.prt_key_name === 'F') {
                        if (
                            this.newOperationState.source &&
                            (this.newOperationState.amountSharesIndicator || this.newOperationState.operationObj.is_total_transfer) &&
                            this.newOperationState.operationObj.xt_isin_code && this.isValidISIN(this.newOperationState.operationObj.xt_isin_code) &&
                            (this.newOperationState.operationObj.xt_gestor || this.newOperationState.operationObj.xt_provider) &&
                            (!this.nrbeRequired || this.newOperationState.operationObj.xt_provider_official_reg_number) &&
                            this.newOperationState.operationObj.xt_fund_name
                        ) {
                            if (!this.newOperationState.operationObj.is_total_transfer) {
                                if (this.newOperationState.amountSharesIndicator.key === 'P') {
                                    // Participaciones
                                    canSubmit =
                                        Number(
                                            this.minSuscription / this.newOperationState.productSelected.net_asset_value
                                        ) <= Number(shares);
                                } else if (this.newOperationState.amountSharesIndicator.key === 'B') {
                                    // Importe bruto
                                    canSubmit =
                                        Number(this.minSuscription) <=
                                        Number(grossAmount);
                                }
                            } else {
                                // Traspaso total
                                canSubmit = this.newOperationState.operationObj.is_total_transfer;
                            }
                        }
                    } else if (
                        // De Planes de pensiones
                        this.newOperationState.source &&
                        (this.newOperationState.amountSharesIndicator || this.newOperationState.operationObj.is_total_transfer) &&
                        this.newOperationState.operationObj.pp_plan_type &&
                        this.newOperationState.operationObj.xt_fund_name &&
                        this.newOperationState.operationObj.pp_xt_dgs_code &&
                        this.newOperationState.operationObj.pp_xt_egs_code &&
                        this.newOperationState.operationObj.pp_source_situation &&
                        this.newOperationState.operationObj.pp_compartment &&
                        this.newOperationState.operationObj.pp_rights_type
                    ) {
                        if (!this.newOperationState.operationObj.is_total_transfer) {
                            if (this.newOperationState.amountSharesIndicator.key === 'P') {
                                canSubmit =
                                    Number(this.minSuscription / this.newOperationState.productSelected.net_asset_value) <=
                                    Number(shares);
                            } else if (this.newOperationState.amountSharesIndicator.key === 'B') {
                                canSubmit = this.newOperationState.operationObj.is_total_transfer
                                    ? this.newOperationState.operationObj.is_total_transfer
                                    : Number(this.minSuscription) <= Number(grossAmount);
                            }
                        } else {
                            // Traspaso total
                            canSubmit = this.newOperationState.operationObj.is_total_transfer;
                        }
                    }
                    break;
                case 'APORTACION':
                    // TODO: Añadir que haga falta aportante si se marca eso
                    if (
                        this.newOperationState.source &&
                        netAmount &&
                        (grossAmount || shares) &&
                        this.newOperationState.operationObj.pay_method &&
                        Number(this.newOperationState.min_contribution) <= Number(grossAmount) &&
                        (this.newOperationState.bankAccount || isPayMethodCheck)
                    ) {
                        canSubmit = true;
                        if (this.newOperationState.hasNewContributor &&
                            (!this.newOperationState.hasMailingTypeNewContributor || !this.newOperationState.newContributors.length )
                        ) {
                            canSubmit = false;
                        }

                        if (this.newOperationState.hasNewBeneficiaries && !this.newOperationState.newBeneficiaries.length ) {
                            canSubmit = false;
                        }
                    }
                    break;
                case 'SOLICITUD_APORTACION_PERIODICA':
                    // TODO: Añadir que haga falta aportante si se marca eso
                    if (
                        this.newOperationState.source &&
                        netAmount &&
                        this.newOperationState.operationObj.pay_method &&
                        (grossAmount || shares) &&
                        this.newOperationState.operationObj.per_period &&
                        this.newOperationState.operationObj.per_start_date &&
                        (this.newOperationState.operationObj.is_per_end_date_undefined === true || this.newOperationState.operationObj.per_end_date) &&
                        this.newOperationState.bankAccount &&
                        (this.newOperationState.operationObj.per_increase_type.key === 'no-increase' ||
                            (this.newOperationState.operationObj.per_increase &&
                                this.newOperationState.operationObj.per_increase_period)) &&
                        Number(this.newOperationState.min_contribution) <=
                            Number(grossAmount)
                    ) {
                        canSubmit = true;

                        if (this.newOperationState.hasNewContributor &&
                            (!this.newOperationState.hasMailingTypeNewContributor || !this.newOperationState.newContributors.length )
                        ) {
                            canSubmit = false;
                        }

                        if (this.newOperationState.hasNewBeneficiaries && !this.newOperationState.newBeneficiaries.length ) {
                            canSubmit = false;
                        }
                        if (!this.newOperationState.operationObj.isValidPeridicity) {
                            canSubmit = false;
                        }
                    }
                    break;
                case 'RESCATE':
                    if (
                        this.newOperationState.source &&
                        this.newOperationState.operationObj.pp_redemption_cause &&
                        (this.newOperationState.operationObj.pp_redemption_cause.key !== 'VARIACION_PRESTACION' ||
                            (this.newOperationState.operationObj.pp_redemption_rendering_variation_type &&
                                (this.newOperationState.operationObj.pp_redemption_rendering_variation ||
                                    this.newOperationState.operationObj.pp_redemption_rendering_variation_date))) &&
                        this.newOperationState.operationObj.pp_redemption_collection_method &&
                        this.newOperationState.operationObj.pp_redemption_defer &&
                        grossAmount &&
                        this.newOperationState.operationObj.pp_source_situation &&
                        this.newOperationState.operationObj.pp_compartment &&
                        this.newOperationState.bankAccount &&
                        this.newOperationState.operationObj.pp_redemption_entitlement_date &&
                        grossAmount <= this.newOperationState.maxPositionsToRefund
                    ) {
                        if (this.newOperationState.operationObj.pp_redemption_collection_method.key === 'MIXTA') {
                            // Si es mixta necesita datos de periodicidad y pp_redemption_mixed_amount
                            if (
                                this.newOperationState.operationObj.per_period &&
                                this.newOperationState.operationObj.per_start_date &&
                                this.newOperationState.operationObj.per_end_date &&
                                this.newOperationState.operationObj.pp_redemption_mixed_amount
                            ) {
                                canSubmit = true;
                            }
                        } else if (
                            this.newOperationState.operationObj.pp_redemption_collection_method.key === 'FINANCIERA'
                        ) {
                            // Si es financiera necesita los datos de periodicidad
                            if (
                                this.newOperationState.operationObj.per_period &&
                                this.newOperationState.operationObj.per_start_date &&
                                this.newOperationState.operationObj.per_end_date
                            ) {
                                canSubmit = true;
                            }
                        } else {
                            // El resto de casos, los datos de periodicidad no son necesarios/no aplican
                            canSubmit = true;
                        }
                    }
                    break;
                default:
                    break;
            }
            return canSubmit;
        },
        /**
         * @return {Number} minimal amount
         */
        minSuscription() {
            return this.productMinimums.minimum_investment;
        },
        maxSuscription() {
            return this.productMinimums.maximum_investment ? this.productMinimums.maximum_investment : Infinity;
        },
        /**
         * @return {Number} minimal amount
         */
        minToMantain() {
            return this.productMinimums.minimum_to_maintain;
        },
        showDisclaimer() {
            const operationState = this.newOperationState;
            if (!operationState || !operationState.operationObj.grossAmount || operationState.operationObj.grossAmount <= 0) {
                return false;
            }

            // Para traspasos internos, verificar el producto destino
            let productToCheck = operationState.productSelected;
            if (operationState.operationTypeSelected.key_name === 'SOLICITUD_TRASPASO_INTERNO' &&
                operationState.operationObj.product_target) {
                productToCheck = operationState.operationObj.product_target;
            }

            return productToCheck && productToCheck.juridical_form === 'F.I.L.';
        },
        filteredRelatedOperations() {
            const productKey = this.newOperationState.productSelected.key_name;
            return (this.relatedOperations || []).filter( op => op.key_product === productKey);
        },
        hasPendingTotalRedemption() {
            return this.filteredRelatedOperations.some(op => op.is_total_redemption === true);
        },
        isRefundOperation() {
            const key = this.newOperationState.operationTypeSelected.key_name;
            return ['REEMBOLSO', 'REEMBOLSO_PERIODICO', 'SOLICITUD_REEMBOLSO_PERIODICO'].includes(key);
        },
        correctAndResendMode() {
          let parent = this.$parent;
          while (parent) {
            if (parent.hasOwnProperty('correctAndResendMode')) {
              return parent.correctAndResendMode;
            }
            parent = parent.$parent;
          }
          return false;
        }
    },
    methods: {
        async loadInternalMinTarget(productKey) {
            try {
              const params = {
                key_name: productKey,
                investor_class: this.newOperationState.account.investor_class,
                is_employed: this.newOperationState.employee,
                is_first_investment: !this.newOperationState.targetIsSuccesiveOperation
              };
              const res = await this.$productsService.getMinimums({ params });
              this.internalMinTarget = res.data.minimums;
              
            } catch (err) {
              console.error('No pude cargar mínimos destino:', err);
            }
        },
        async getProductMinimums(productKey, isFirstInvestment) {
            const params = {
                key_name: productKey,
                investor_class: this.newOperationState.account.investor_class,
                is_employed: this.newOperationState.employee,
                is_first_investment: isFirstInvestment
            };
            const response = await this.$productsService.getMinimums({ params });

            return response.data.minimums;
        },
        getAutoClassBaseProduct() {
            if (
                this.newOperationState.operationTypeSelected.key_name === 'SOLICITUD_TRASPASO_INTERNO' &&
                this.newOperationState.operationObj.product_target
            ) {
                return this.newOperationState.operationObj.product_target;
            }

            return this.newOperationState.productSelected;
        },
        getAutoClassSelectionWarning(product) {
            const originProduct = this.newOperationState.productList.find(familyProduct => {
                return familyProduct.parent_class_name === product.parent_class_name &&
                    familyProduct.class !== product.class &&
                    this.getAccountProductPosition(familyProduct) > 0;
            });

            if (!originProduct) return null;

            return {
                originProduct,
                targetProduct: product
            };
        },
        getAccountProductPosition(product) {
            const accountProduct = (this.newOperationState.account.products || {})[product.key_name];
            if (!accountProduct) return 0;

            return Number(accountProduct.positions || 0);
        },
        getUpperClassIncomingAmount() {
            const operationObj = this.newOperationState.operationObj || {};
            const indicator = this.newOperationState.amountSharesIndicator &&
                this.newOperationState.amountSharesIndicator.key;

            if (indicator === 'P') {
                return Number(operationObj.shares || 0) * Number(this.newOperationState.productSelected.net_asset_value || 0);
            }

            if (indicator === 'T') {
                return Number(this.availableShares || 0) * Number(this.newOperationState.productSelected.net_asset_value || 0);
            }

            return Number(operationObj.grossAmount || operationObj.netAmount || 0);
        },
        async getUpperClassSelectionWarning() {
            if (!this.allowAutoClassSelection) return null;

            const operationType = this.newOperationState.operationTypeSelected &&
                this.newOperationState.operationTypeSelected.key_name;
            if (!AUTO_CLASS_ENTRY_OPERATIONS.includes(operationType)) return null;

            const selectedProduct = this.getAutoClassBaseProduct();
            if (!selectedProduct) return null;

            const incomingAmount = this.getUpperClassIncomingAmount();
            if (incomingAmount <= 0) return null;

            const currentBalance = this.getAccountProductPosition(selectedProduct);
            const resultingBalance = currentBalance + incomingAmount;
            const selectedClassOrder = Number(selectedProduct.class_order);
            if (!Number.isFinite(selectedClassOrder)) return null;

            const upperProduct = this.newOperationState.productList
                .filter(product =>
                    product.parent_class_name === selectedProduct.parent_class_name &&
                    product.is_web_visible === true &&
                    Number(product.class_order) > selectedClassOrder
                )
                .sort((a, b) => Number(a.class_order) - Number(b.class_order))[0];
            if (!upperProduct) return null;

            let upperMinimums;
            try {
                upperMinimums = await this.getProductMinimums(
                    upperProduct.key_name,
                    this.getAccountProductPosition(upperProduct) <= 0
                );
            } catch (err) {
                console.error('Error al obtener el mínimo de la clase superior:', err);
                return null;
            }

            const minimumInvestment = Number(upperMinimums.minimum_investment || 0);
            if (!minimumInvestment || resultingBalance < minimumInvestment) return null;

            return {
                selectedProduct,
                upperProduct,
                minimumInvestment,
                currentBalance,
                incomingAmount
            };
        },
        showAutoClassSelectionWarning(isNew) {
            this.autoClassWarning = this.autoClassSelectionWarning;
            this.pendingAutoClassSubmitIsNew = isNew;
            this.$bvModal.show('modalAutoClassSelectionWarning');
        },
        closeAutoClassSelectionWarning() {
            this.pendingAutoClassSubmitIsNew = null;
            this.$bvModal.hide('modalAutoClassSelectionWarning');
        },
        confirmAutoClassSelectionWarning() {
            const isNew = this.pendingAutoClassSubmitIsNew;
            this.autoClassWarningAccepted = true;
            this.pendingAutoClassSubmitIsNew = null;
            this.$bvModal.hide('modalAutoClassSelectionWarning');
            this.onSubmitOperation(isNew);
        },
        showUpperClassSelectionWarning(warning, isNew) {
            this.upperClassWarning = warning;
            this.pendingUpperClassSubmitIsNew = isNew;
            this.$bvModal.show('modalUpperClassSelectionWarning');
        },
        closeUpperClassSelectionWarning() {
            this.pendingUpperClassSubmitIsNew = null;
            this.autoClassWarningAccepted = false;
            this.$bvModal.hide('modalUpperClassSelectionWarning');
        },
        confirmUpperClassSelectionWarning() {
            const isNew = this.pendingUpperClassSubmitIsNew;
            this.upperClassWarningAccepted = true;
            this.pendingUpperClassSubmitIsNew = null;
            this.$bvModal.hide('modalUpperClassSelectionWarning');
            this.onSubmitOperation(isNew);
        },
        /**
         * Submit seleccion -> show modal
         */
        onSubmitSeleccion() {
            if (Number(this.newOperationState.operationObj.grossAmount) < Number(this.minSuscription)) {
                this.modalConcentradosShown = true;
                this.$bvModal.show('modalConcentradosOperation');
            } else {
                this.onSubmitOperation(!this.newOperationState.isEdition);
            }
        },
        /**
         * Cancel submit seleccion -> close modal
         */
        cancelSeleccion() {
            this.modalConcentradosShown = false;
            this.$bvModal.hide('modalConcentradosOperation');
        },
        /**
         * Send operation info to the back-end
         * @param {Boolean} isNew control if is a creation or an update
         */
        async onSubmitOperation(isNew) {
            if (!this.canSubmitOperation || !this.allowSubmit || this.limitExceeded)  {
                return;
            }
            if (this.autoClassSelectionWarning && !this.autoClassWarningAccepted) {
                this.showAutoClassSelectionWarning(isNew);
                return;
            }
            if (!this.upperClassWarningAccepted) {
                const upperClassWarning = await this.getUpperClassSelectionWarning();
                if (upperClassWarning) {
                    this.showUpperClassSelectionWarning(upperClassWarning, isNew);
                    return;
                }
            }
            this.autoClassWarningAccepted = false;
            this.upperClassWarningAccepted = false;
            if (this.modalConcentradosShown) {
                this.$bvModal.hide('modalConcentradosOperation');
            }
            if (this.canSubmitOperation && this.allowSubmit) {
                this.allowSubmit = false;
                let doSubmit = false;
                let doCreateContributor = false;
                let doCreateBeneficiaries = false;

                // Body comun a todas las operaciones
                this.operationPostBody = {
                    uuid_account: this.newOperationState.account.uuid,
                    uuid_ordering: this.newOperationState.ordering.uuid,
                    key_operation_type: this.newOperationState.operationTypeSelected.key_name,
                    key_product: this.newOperationState.productSelected.key_name,
                    uuid_distributor: this.newOperationState.account.uuid_distributor,
                    uuid_subdistributor: this.newOperationState.account.uuid_subdistributor,
                    source: this.newOperationState.source,
                    notify_operation: this.newOperationState.notifyOperation,
                    is_private: this.newOperationState.privateOperation,
                    is_total_redemption: this.newOperationState.operationObj.is_total_redemption,
                    is_total_transfer: this.newOperationState.operationObj.is_total_transfer,
                    employee: this.newOperationState.employee,
                    can_be_validated: true,
                    nav_date:
                        this.newOperationState.productSelected.juridical_form === 'F.I.L.' &&
                        this.newOperationState.operationObj.nav_date &&
                        this.newOperationState.operationObj.nav_date !== this.getFilNavDate(this.newOperationState)
                        ? this.newOperationState.operationObj.nav_date
                        : this.getFilNavDate(this.newOperationState),
                };

                const operationsPeriodicsAllowed = [
                    'REEMBOLSO_PERIODICO',
                    'SUSCRIPCION_PERIODICA',
                    'SUSCRIPCION_PERIODICA',
                    'SOLICITUD_SUSCRIPCION_PERIODICA',
                    'APORTACION_PERIODICA',
                    'SOLICITUD_APORTACION_PERIODICA',
                    'SOLICITUD_REEMBOLSO_PERIODICO'
                ];
                if (operationsPeriodicsAllowed.includes(this.operationPostBody.key_operation_type)) {
                    this.operationPostBody.is_periodic = true;
                }

                if (this.newOperationState.amountSharesIndicator && !this.operationPostBody.is_total_transfer) {
                    switch (this.newOperationState.amountSharesIndicator.key) {
                        // Importe bruto
                        case 'B':
                            this.operationPostBody.gross_amount = Number(
                                this.newOperationState.operationObj.grossAmount
                            );
                            break;
                        // Importe neto
                        case 'I':
                            this.operationPostBody.net_amount = Number(this.newOperationState.operationObj.netAmount);
                            break;
                        // Participaciones
                        case 'P':
                            this.operationPostBody.shares = Number(this.newOperationState.operationObj.shares);
                            break;
                        default:
                            break;
                    }
                }

                // control de la fecha final (ajustándolo al día de hoy o al start_date si hay)
                if (this.newOperationState.operationObj.is_per_end_date_undefined === true) {
                    this.operationPostBody.per_end_date = undefined;
                } else if (this.newOperationState.operationObj.per_end_date && this.newOperationState.operationObj.per_end_date !== 'undefined') {
                    let dateStart = this.$moment();
                    let dayStart = dateStart.date();
                    if (this.newOperationState.operationObj.per_start_date) {
                        dateStart = this.$moment(this.newOperationState.operationObj.per_start_date);
                        dayStart = dateStart.date();
                    }
                    const dateFinish = this.$moment(this.newOperationState.operationObj.per_end_date);
                    const daysOfFinishMonth = dateFinish.daysInMonth();
                    // Si el dia del mes de inicio es mayor al número de días del mes, se pone el último día del mes
                    // por ejemplo, si se elige el día 31 de marzo de 2020 como inicio y febrero de 2021 de fin el día de fin será el último día de febrero de 2021 (28)
                    const dayEnd = dayStart > daysOfFinishMonth ? daysOfFinishMonth : dayStart;
                    this.operationPostBody.per_end_date = dateFinish.set('date', dayEnd).format('YYYY-MM-DD');
                }

                switch (this.newOperationState.operationTypeSelected.key_name) {
                    case 'REEMBOLSO':
                    case 'REEMBOLSO_PERIODICO':
                        this.operationPostBody.uuid_bank_account = this.newOperationState.bankAccount.uuid;
                        this.operationPostBody.amount_shares_indicator =
                            this.newOperationState.amountSharesIndicator.key === 'T'
                                ? null
                                : this.newOperationState.amountSharesIndicator.key;
                        this.operationPostBody.is_total_redemption =
                            this.newOperationState.amountSharesIndicator.key === 'T';

                        doSubmit = true;
                        break;

                    case 'SOLICITUD_REEMBOLSO_PERIODICO':
                        this.operationPostBody.uuid_bank_account = this.newOperationState.bankAccount.uuid;
                        this.operationPostBody.amount_shares_indicator =
                            this.newOperationState.amountSharesIndicator.key === 'T'
                                ? null
                                : this.newOperationState.amountSharesIndicator.key;
                        this.operationPostBody.is_total_redemption =
                            this.newOperationState.amountSharesIndicator.key === 'T';
                        this.operationPostBody.per_start_date = this.newOperationState.operationObj.per_start_date;
                        this.operationPostBody.per_period = this.newOperationState.operationObj.per_period.key;

                        if (this.newOperationState.operationObj.per_increase_type.key !== 'no-increase') {
                            this.operationPostBody.per_increase_type = this.newOperationState.operationObj.per_increase_type.key;
                            this.operationPostBody.per_increase = this.newOperationState.operationObj.per_increase;
                            this.operationPostBody.per_increase_period = this.newOperationState.operationObj.per_increase_period.key;
                        } else {
                            delete this.operationPostBody.per_increase_type;
                            delete this.operationPostBody.per_increase;
                            delete this.operationPostBody.per_increase_period;
                        }

                        doSubmit = true;
                        break;
                    case 'SUSCRIPCION':
                    case 'SUSCRIPCION_PERIODICA':
                        this.operationPostBody.amount_shares_indicator = 'B';
                        this.operationPostBody.gross_amount = Number(this.newOperationState.operationObj.grossAmount);
                        this.operationPostBody.pay_method = this.newOperationState.operationObj.pay_method.name;
                        if (this.operationPostBody.pay_method !== 'CHEQUE') {
                            this.operationPostBody.uuid_bank_account = this.newOperationState.bankAccount.uuid;
                        }
                        doSubmit = true;
                        break;

                    case 'SOLICITUD_SUSCRIPCION_PERIODICA':
                        this.operationPostBody.amount_shares_indicator = 'B';
                        this.operationPostBody.gross_amount = Number(this.newOperationState.operationObj.grossAmount);
                        this.operationPostBody.per_period = this.newOperationState.operationObj.per_period.key;
                        this.operationPostBody.per_start_date = this.newOperationState.operationObj.per_start_date;
                        this.operationPostBody.pay_method = this.newOperationState.operationObj.pay_method.name;
                        this.operationPostBody.uuid_bank_account = this.newOperationState.bankAccount.uuid;

                        if (this.newOperationState.operationObj.per_increase_type.key !== 'no-increase') {
                            this.operationPostBody.per_increase_type = this.newOperationState.operationObj.per_increase_type.key;
                            this.operationPostBody.per_increase = this.newOperationState.operationObj.per_increase;
                            this.operationPostBody.per_increase_period = this.newOperationState.operationObj.per_increase_period.key;
                        } else {
                            delete this.operationPostBody.per_increase_type;
                            delete this.operationPostBody.per_increase;
                            delete this.operationPostBody.per_increase_period;
                        }
                        doSubmit = true;
                        break;

                    case 'SOLICITUD_TRASPASO_INTERNO':
                        if (this.newOperationState.amountSharesIndicator.key === 'T') {
                            this.operationPostBody.amount_shares_indicator = null;
                            this.operationPostBody.is_total_transfer = true;
                        } else if (this.newOperationState.amountSharesIndicator.key === 'P') {
                            this.operationPostBody.amount_shares_indicator = 'P';
                            this.operationPostBody.shares = Number(this.newOperationState.operationObj.shares);
                        } else {
                            this.operationPostBody.amount_shares_indicator = 'B';
                            this.operationPostBody.gross_amount = Number(
                                this.newOperationState.operationObj.grossAmount
                            );
                        }
                        this.operationPostBody.key_target_product = this.newOperationState.operationObj.product_target.key_name;

                        doSubmit = true;
                        break;

                    case 'SOLICITUD_TRASPASO_EXTERNO_ENTRADA':
                        if (this.newOperationState.amountSharesIndicator && this.newOperationState.amountSharesIndicator.key) {
                            this.operationPostBody.amount_shares_indicator = this.newOperationState.amountSharesIndicator.key;
                        } else {
                            this.operationPostBody.amount_shares_indicator = 'B';
                        }

                        if (this.operationPostBody.is_total_transfer) {
                            // Traspaso total
                            this.operationPostBody.shares = 0;
                            this.operationPostBody.gross_amount = 0;
                        } else if (this.newOperationState.amountSharesIndicator.key === 'P') {
                                // Participaciones o importe bruto
                                this.operationPostBody.shares = Number(this.newOperationState.operationObj.shares);
                                this.operationPostBody.gross_amount = 0;
                        } else {
                            this.operationPostBody.gross_amount = Number(
                                this.newOperationState.operationObj.grossAmount
                            );
                            this.operationPostBody.shares = 0;
                        }
                        this.operationPostBody.key_target_product = this.newOperationState.productSelected.key_name;
                        this.operationPostBody.contribution_account_code = this.newOperationState.operationObj.contribution_account_code

                        if (this.newOperationState.operationTypeSelected.prt_key_name === 'F') {
                            this.operationPostBody.xt_isin_code = this.newOperationState.operationObj.xt_isin_code;
                            this.operationPostBody.xt_fund_name = this.newOperationState.operationObj.xt_fund_name;
                            this.operationPostBody.xt_fund_official_reg_number = this.newOperationState.operationObj.xt_fund_official_reg_number;
                            this.operationPostBody.xt_fund_nif = this.newOperationState.operationObj.xt_fund_nif;
                            this.operationPostBody.xt_gestor = this.newOperationState.operationObj.xt_gestor;
                            this.operationPostBody.xt_gestor_official_reg_number = this.newOperationState.operationObj.xt_gestor_official_reg_number;
                            this.operationPostBody.xt_gestor_nif = this.newOperationState.operationObj.xt_gestor_nif;
                            this.operationPostBody.xt_provider = this.newOperationState.operationObj.xt_provider;
                            this.operationPostBody.xt_provider_official_reg_number = this.newOperationState.operationObj.xt_provider_official_reg_number;
                            this.operationPostBody.xt_provider_nif = this.newOperationState.operationObj.xt_provider_nif;
                            this.operationPostBody.xt_account_origin = this.newOperationState.operationObj.xt_account_origin || 111;
                        } else {
                            this.operationPostBody.pp_plan_type = this.newOperationState.operationObj.pp_plan_type.key;
                            this.operationPostBody.xt_fund_name = this.newOperationState.operationObj.xt_fund_name;
                            this.operationPostBody.pp_xt_dgs_code = this.newOperationState.operationObj.pp_xt_dgs_code;
                            this.operationPostBody.pp_xt_egs_code = this.newOperationState.operationObj.pp_xt_egs_code;
                            this.operationPostBody.pp_source_situation = this.newOperationState.operationObj.pp_source_situation.key;
                            this.operationPostBody.xt_account_origin = this.newOperationState.operationObj.xt_account_origin || 111;
                            this.operationPostBody.pp_compartment = this.newOperationState.operationObj.pp_compartment.key;
                            this.operationPostBody.pp_rights_type = this.newOperationState.operationObj.pp_rights_type.key;
                            this.operationPostBody.pp_xt_collection_method = this.newOperationState.operationObj.pp_xt_collection_method
                                ? this.newOperationState.operationObj.pp_xt_collection_method.key
                                : this.newOperationState.operationObj.pp_xt_collection_method;
                        }
                        doSubmit = true;
                        break;
                    case 'APORTACION':
                        this.operationPostBody.amount_shares_indicator = 'B';
                        this.operationPostBody.gross_amount = Number(this.newOperationState.operationObj.grossAmount);
                        this.operationPostBody.pay_method = this.newOperationState.operationObj.pay_method.name;
                        if (this.operationPostBody.pay_method !== 'CHEQUE') {
                            this.operationPostBody.uuid_bank_account =  this.newOperationState.bankAccount.uuid;
                        }
                        if (this.newOperationState.operationObj.pay_method.name === 'DOMICILIACION') {
                            this.operationPostBody.uuid_bank_account = this.newOperationState.bankAccount.uuid;
                        }
                        doSubmit = true;
                        if (this.newOperationState.hasNewContributor) {
                            doCreateContributor = true;
                        }
                        if (this.newOperationState.hasNewBeneficiaries) {
                            doCreateBeneficiaries = true;
                        }

                        break;

                    case 'SOLICITUD_APORTACION_PERIODICA':
                        this.operationPostBody.amount_shares_indicator = 'B';
                        this.operationPostBody.gross_amount = Number(this.newOperationState.operationObj.grossAmount);
                        this.operationPostBody.pay_method = this.newOperationState.operationObj.pay_method.name;
                        this.operationPostBody.per_period = this.newOperationState.operationObj.per_period.key;
                        this.operationPostBody.per_start_date = this.$moment(
                            this.newOperationState.operationObj.per_start_date
                        ).format('YYYY-MM-DD');
                        this.operationPostBody.uuid_bank_account = this.newOperationState.bankAccount.uuid;

                        if (this.newOperationState.operationObj.per_increase_type.key !== 'no-increase') {
                            this.operationPostBody.per_increase_type = this.newOperationState.operationObj.per_increase_type.key;
                            this.operationPostBody.per_increase = this.newOperationState.operationObj.per_increase;
                            this.operationPostBody.per_increase_period = this.newOperationState.operationObj.per_increase_period.key;
                        } else {
                            delete this.operationPostBody.per_increase_type;
                            delete this.operationPostBody.per_increase;
                            delete this.operationPostBody.per_increase_period;
                        }
                        doSubmit = true;
                        if (this.newOperationState.hasNewContributor) {
                            doCreateContributor = true;
                        }
                        if (this.newOperationState.hasNewBeneficiaries) {
                            doCreateBeneficiaries = true;
                        }
                        break;

                    case 'RESCATE':
                        this.operationPostBody.amount_shares_indicator = 'B';
                        this.operationPostBody.gross_amount = Number(this.newOperationState.operationObj.grossAmount);
                        this.operationPostBody.uuid_bank_account = this.newOperationState.bankAccount.uuid;
                        this.operationPostBody.pp_redemption_cause = this.newOperationState.operationObj.pp_redemption_cause.key;

                        if (this.operationPostBody.pp_redemption_cause === 'VARIACION_PRESTACION') {
                            this.operationPostBody.pp_redemption_rendering_variation_type = this.newOperationState.operationObj.pp_redemption_rendering_variation_type.key;
                            if (
                                this.newOperationState.operationObj.pp_redemption_rendering_variation_type.key ===
                                'ADELANTO_COBRO'
                            ) {
                                this.operationPostBody.pp_redemption_rendering_variation_date = this.newOperationState.operationObj.pp_redemption_rendering_variation_date;
                                delete this.operationPostBody.pp_redemption_rendering_variation;
                            } else {
                                this.operationPostBody.pp_redemption_rendering_variation = this.newOperationState.operationObj.pp_redemption_rendering_variation;
                                delete this.operationPostBody.pp_redemption_rendering_variation_date;
                            }
                        } else {
                            delete this.operationPostBody.pp_redemption_rendering_variation_type;
                            delete this.operationPostBody.pp_redemption_rendering_variation_date;
                            delete this.operationPostBody.pp_redemption_rendering_variation;
                        }

                        this.operationPostBody.pp_redemption_defer = this.newOperationState.operationObj.pp_redemption_defer.key;
                        this.operationPostBody.pp_source_situation = this.newOperationState.operationObj.pp_source_situation.key;
                        this.operationPostBody.pp_compartment = this.newOperationState.operationObj.pp_compartment.key;

                        this.operationPostBody.pp_redemption_collection_method = this.newOperationState.operationObj.pp_redemption_collection_method.key;
                        if (this.newOperationState.operationObj.pp_redemption_collection_method.key !== 'TOTAL') {
                            this.operationPostBody.per_period = this.newOperationState.operationObj.per_period.key;
                            this.operationPostBody.per_start_date = this.$moment(
                                this.newOperationState.operationObj.per_start_date
                            ).format('YYYY-MM-DD');

                            if (this.newOperationState.operationObj.per_increase_type.key !== 'no-increase') {
                                this.operationPostBody.per_increase_type = this.newOperationState.operationObj.per_increase_type.key;
                                this.operationPostBody.per_increase = this.newOperationState.operationObj.per_increase;
                                this.operationPostBody.per_increase_period = this.newOperationState.operationObj.per_increase_period.key;
                            } else {
                                delete this.operationPostBody.per_increase_type;
                                delete this.operationPostBody.per_increase;
                                delete this.operationPostBody.per_increase_period;
                            }

                            if (this.newOperationState.operationObj.pp_redemption_collection_method.key === 'MIXTA') {
                                this.operationPostBody.pp_redemption_mixed_amount = Number(
                                    this.newOperationState.operationObj.pp_redemption_mixed_amount
                                );
                            }
                            this.operationPostBody.pp_redemption_entitlement_date = this.$moment(
                                this.newOperationState.operationObj.pp_redemption_entitlement_date
                            ).format('YYYY-MM-DD');
                        } else {
                            this.operationPostBody.pp_redemption_entitlement_date = this.newOperationState.operationObj.pp_redemption_entitlement_date;
                        }

                        doSubmit = true;
                        break;
                    default:
                        break;
                }
                if (doSubmit) {
                    try {
                        this.operationPostBody.uuid_contributor = await this.createContributor(this.newOperationState, doCreateContributor);

                        if (doCreateBeneficiaries) {
                            const payload = {
                                key_product: this.newOperationState.productSelected.key_name,
                                beneficiaries: this.newOperationState.newBeneficiaries
                            };
                            await this.$accountsService.createBeneficiaries(this.newOperationState.account.uuid, payload);
                        }

                        if (isNew) {
                            // Puesto a pincho para evitar el error... preguntando al cliente si debe ser relativo al campo 'source'
                            this.operationPostBody.operation_status = 'REGISTERED_ONLINE';

                            if (this.$route.query.uuid && this.$route.query.type === 'periodic') {
                                this.operationPostBody.is_periodic = true;
                                this.operationPostBody.uuid_request = this.$route.query.uuid;
                            }

                            const res = await this.$operationsService.createOperation(this.operationPostBody);

                            // Auto-envío a RD para mimetype vnd.rd-multicontrato y cuenta FINALIZED
                            const mimetype = atob(localStorage.getItem('BOPLCM'));
                            const accountStatus = this.newOperationState.account.status;
                            const autoSendOperationTypes = ['SOLICITUD_TRASPASO_EXTERNO_ENTRADA', 'SOLICITUD_TRASPASO_INTERNO', 'SUSCRIPCION'];

                            if (
                                mimetype === 'application/vnd.rd-multicontrato' &&
                                accountStatus === 'FINALIZED' &&
                                autoSendOperationTypes.includes(this.newOperationState.operationTypeSelected.key_name)
                            ) {
                                try {
                                    // 1. Establecer operation_date (como hace el bastanteo)
                                    await this.$operationsService.updateOperation(res.data.operation.operation_id, {
                                        operation_date: new Date().toISOString().split('T')[0]
                                    });
                                    // 2. Cambiar status a RD_SENT (programa exportaciones a rd_file_exports)
                                    await this.$operationsService.changeOperationStatus(res.data.operation.operation_id, {
                                        status: 'RD_SENT'
                                    });
                                } catch (autoSendErr) {
                                    console.error('Error en auto-envío a RD:', autoSendErr);
                                }
                            }

                            this.$toast.success('OK', 'Operación correctamente creada');
                            const menuItems = this.$store.getters['yuriMenuStore/items'];
                            let indexMenu = 0;
                            for (let index = 0; index < menuItems.length; index++) {
                                const element = menuItems[index];
                                if (element.route.name === 'operations_add') {
                                    indexMenu = index;
                                }
                            }

                            this.$store.dispatch('yuriMenuStore/removeItem', indexMenu).then(() => {
                                const _route = {
                                    name: 'operations_uuid',
                                    params: { uuid: res.data.operation.operation_id }
                                };
                                const item = {
                                    route: _route,
                                    name: res.data.operation.id_object,
                                    active: true
                                };
                                this.$store.dispatch('yuriMenuStore/disableItemsMenu').then(() => {
                                    this.$store.dispatch('yuriMenuStore/upsertItem', item).then(() => {
                                        this.$router.replace(item.route);
                                    });
                                    this.$store.dispatch('yuriMenuStore/setActiveItem', item);
                                });
                            });
                        } else {
                            const isCorrectAndResend = this.correctAndResendMode;

                            if (isCorrectAndResend) {
                                this.operationPostBody.resend_operation = true;
                                this.operationPostBody.operation_status = 'RD_SENT';
                            }

                            // Remove empty nav_date for correct and resend operations
                            if (this.operationPostBody.nav_date === "" || this.operationPostBody.nav_date === null) {
                                delete this.operationPostBody.nav_date;
                            }

                            await this.$operationsService.updateOperation(this.newOperationState.uuid_operation, this.operationPostBody);

                            const successMessage = isCorrectAndResend
                                ? 'Operación corregida y reenviada correctamente'
                                : 'Operación actualizada correctamente';

                            this.$toast.success('OK', successMessage);
                            await this.$nextTick();

                            if (isCorrectAndResend) {
                                this.$emit('close_correct_and_resend_operation');
                            } else {
                                this.$emit('close_edit_operation');
                            }
                        }
                        this.$emit('delete_operation_store');
                    } catch (err) {
                        console.error(err);
                        this.$toast.error(`Error ${err.name}`, `${err.message}`);
                        this.allowSubmit = true;
                    }
                } else {
                    this.$toast.error('Error', 'Not implemented yet');
                }
            }
        },
        isValidISIN(val) {
            if (val.match(/([A-Z]{2})([A-Z0-9]{9})([0-9]{1})$/) &&
             !this.newOperationState.productList.some(p => p.isin_code === val)) {
                return true;
            } else {
                return false;
            }
        },

        getFilAlert(operation) {
            // Para traspasos internos, usar el producto destino
            let productToCheck = operation.productSelected;
            if (operation.operationTypeSelected.key_name === 'SOLICITUD_TRASPASO_INTERNO' &&
                operation.operationObj.product_target) {
                productToCheck = operation.operationObj.product_target;
            }

            if (productToCheck && productToCheck.juridical_form === 'F.I.L.') {
                return generateFilAlert(
                    operation.operationTypeSelected.key_name,
                    operation.operationObj.grossAmount,
                    new Date(),
                    productToCheck.notice_days_detail
                );
            }
            return '';
        },

        getFilNavDate(operation) {
            // Para traspasos internos, usar el producto destino
            let productToCheck = operation.productSelected;
            if (operation.operationTypeSelected.key_name === 'SOLICITUD_TRASPASO_INTERNO' &&
                operation.operationObj.product_target) {
                productToCheck = operation.operationObj.product_target;
            }

            if (productToCheck && productToCheck.juridical_form === 'F.I.L.') {
                return generateFilNavDate(
                    operation.operationTypeSelected.key_name,
                    operation.operationObj.grossAmount,
                    new Date(),
                    productToCheck.notice_days_detail
                );
            }
            return null;
        },

        async createContributor(newOperationState, doCreateContributor) {
            const hasNewContributors = newOperationState.newContributors && newOperationState.newContributors.length;
            let uuid_contributor;
            if (doCreateContributor && hasNewContributors) {
                if ( !newOperationState.existingContributor ) {
                    const contributorsPayload = newOperationState.newContributors.map(x => {
                        return {
                            name: x._data.personalData.name,
                            lastname_1: x._data.personalData.lastname_1,
                            lastname_2: x._data.personalData.lastname_2 || '',
                            birthdate: x._data.personalData.birthdate,
                            marital_status: x._data.personalData.marital_status,
                            key_mobile_phone_prefix: x._data.contactData.key_mobile_phone_prefix,
                            mobile_phone: x._data.contactData.mobile_phone,
                            email: x._data.contactData.email,
                            document_type: x._data.personalData.document_type,
                            document_id: x._data.personalData.document_id,
                            gender: x._data.personalData.gender,
                            contributor_type: x.account_intervener_role,
                            f_address_street_1: x._data.fiscalData.f_address_street_1,
                            f_address_number: x._data.fiscalData.f_address_number || '',
                            f_address_floor: x._data.fiscalData.f_address_floor || '',
                            f_address_door: x._data.fiscalData.f_address_door || '',
                            f_address_postal_code: x._data.fiscalData.f_address_postal_code,
                            f_address_city: x._data.fiscalData.f_address_city,
                            f_address_state: x._data.fiscalData.f_address_state,
                            f_key_address_country: x._data.fiscalData.f_address_key_country
                        };
                    });
                    const res = await this.$accountsService.createContributors(newOperationState.account.uuid, { contributors: contributorsPayload });
                    uuid_contributor = res.data.contributors[0].uuid;
                } else {
                    uuid_contributor = newOperationState.newContributors[0].uuid;
                }
            }
            return uuid_contributor;
        },

        /**
         * Retrieves the operation created previous to the limitDate
         * @param {*} operations Array sobre el que se busca la operación
         * @return {*} La operación anterior a la fecha límite para retener una participación
         */
        existsOperationBeforeLimitDate(operations) {
            const productsName = [this.newOperationState.productSelected.key_name];

            return operations ?
                operations
                .filter(op => {
                    const isClassChange = op.key_operation_type === 'TRASPASO_CLASE' || op.key_sub_operation_type === 'TC';
                    const isFinalized = op.operation_status === 'FINALIZED';

                    if (isFinalized && isClassChange && !productsName.includes(op.key_product)) {
                        productsName.push(op.key_product);
                    }

                    return !isClassChange && isFinalized &&
                        productsName.includes(op.key_product);
                })
                .find(operation => {
                    let recentDate = new Date(0);
                    const PERIODIC_OPERATION_TYPES = [
                        'SOLICITUD_SUSCRIPCION_PERIODICA',
                        'SOLICITUD_REEMBOLSO_PERIODICO',
                        'SOLICITUD_APORTACION_PERIODICA',
                        'SUSCRIPCION_PERIODICA',
                        'REEMBOLSO_PERIODICO',
                        'APORTACION_PERIODICA'
                    ];
                    const isPeriodic = PERIODIC_OPERATION_TYPES.includes(operation.key_operation_type);
                    if (isPeriodic) {
                        recentDate = operation.per_end_date ? new Date(operation.per_end_date) : new Date();
                    } else {
                        recentDate = operation.operation_date ? new Date(operation.operation_date) : new Date();
                    }

                    return recentDate.getTime() < this.limitDate.getTime();
                }) :
                null;
        },
        /**
         * Obtenemos la información relativa a las operaciones por cuenta seleccionada
         */
        fetchDataOperations() {
            this.uuid = this.id;
            const cfg = {
                params: { }
            };
            cfg.params['$filter'] = `{"operation_status":[{"ne": "FINALIZED" }, {"ne": "CANCELLED" }]}`;
            this.$accountsService.getAccountOperations(this.newOperationState.account.uuid, cfg)
                .then(res => this.relatedOperations = res.data.related_operations);
        },


    }
};
